<template>
  <div class="grid-container fluid">
    <div class="bg-lg grid-x grid-padding-x">
      <div class="cell small-12 medium-8 medium-offset-2">
          <img class="logo" width="100" src="../../public/img/EQRx-Logo.svg" alt="EQRx" />
          <h1>Contact Us</h1>
          <span class="white-space show-for-medium">&nbsp;</span>
      </div>
    </div>
    <form class="contact-form" @submit.prevent="sendFile()">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Title</label>
          <input class="eqrx" v-model="contact.title" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>First Name</label>
          <input class="eqrx" v-model="contact.firstName" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Last Name</label>
          <input class="eqrx" v-model="contact.lastName" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Job Title</label>
          <input class="eqrx" v-model="contact.jobTitle" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Email</label>
          <input class="eqrx" v-model="contact.email" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Organisation</label>
          <input class="eqrx" v-model="contact.organisation" required type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <label><sup>*</sup>Please state your role</label>
          <label>
            <input
              class="eqrx-radio"
              v-model="contact.role"
              type="radio"
              name="role"
              value="Healthcare Professional">
            Healthcare Professional
          </label>
          <label>
            <input
              class="eqrx-radio"
              v-model="contact.role"
              type="radio"
              name="role"
              value="Patient advocate">
            Patient advocate
          </label>
          <label>
            <input
              class="eqrx-radio"
              v-model="contact.role"
              type="radio"
              name="role"
              value="Industry representative">
            Industry representative
          </label>
          <label>
            <input
              class="eqrx-radio"
              v-model="contact.role"
              type="radio"
              name="role"
              value="Other">
            Other (please specify)
          </label>
          <input
            v-if="contact.role === 'Other'"
            class="eqrx"
            v-model="contact.roleother"
            required
            type="text">
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <div class="grid-x">
            <div class="cell small-1">
              <input type="checkbox" v-model="contact.consent">
            </div>
            <div class="cell small-11">
              <p>
                I consent to receive EQRx Inc. email communications about its products, services,
                research, events, programmes and other information, including promotional content,
                that may be of interest to, and appropriate for, me using the information I
                provide. I may withdraw my consent at any time.
              </p>
              <p>
                Please refer to the EQRx privacy notice <router-link to="/privacy-policy">
                here</router-link> for more information on how EQRx processes your personal
                data and your data privacy rights.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-8 medium-offset-2 large-6 large-offset-3">
          <button class="button">Submit</button>
        </div>
      </div>
    </form>
    <footer>
      <div class="red-ball show-for-medium">&nbsp;</div>
      <div class="grid-x grid-padding-x">
        <div class="preparation cell small-12 medium-8 medium-offset-2 large-4 large-offset-4">
          <p>
            The EQRx logo and other trademarks or service marks of EQRx appearing in this
            communication are the property of EQRx.
          </p>
          <p class="code">MAT-NP-0012</p>
          <p class="date">Date of Preparation: April 2023</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'App',
  data() {
    return {
      contact: {
        title: '',
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        organisation: '',
        consent: false,
        role: null,
        roleother: '',
      },
    };
  },
  methods: {
    sendFile() {
      const jsonString = JSON.stringify({
        title: this.contact.title,
        first_name: this.contact.firstName,
        last_name: this.contact.lastName,
        job__title: this.contact.jobTitle,
        email: this.contact.email,
        organisation: this.contact.organisation,
        consent: this.contact.consent,
        role: this.contact.role,
        role_other: this.contact.roleother,
      });
      const fileName = `${Date.now()}.json`;
      const formData = new FormData();
      const file = new File([jsonString], fileName);
      formData.append('file[]', file);
      axios.post(`/Production/${fileName}`, file)
        .then((response) => {
          // eslint-disable-next-line
          console.log('response', response);
        }).catch((error) => {
          // eslint-disable-next-line
          console.log('error', error);
        });
    },
  },
};
</script>
